// use for render UI reactivated
export enum EnumFlowReactivatedLockedAccount {
  MUST_CONTACT_CS = 'MUST_CONTACT_CS',
  CAN_SELF_REACTIVATED_WITH_OTP = 'CAN_SELF_REACTIVATED_WITH_OTP',
}
